module.exports = __webpack_public_path__ + "static/herobg-03fb1a16f267c9afb7fe721abaa03f2c.jpg";